import { useState } from 'react'
import { AdminLoginApi } from "../API's/AdminApi"
import { toast } from 'react-toastify'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { Form, Input, Button, Card, Typography } from 'antd'
import { BUBBLES } from './Data'
const { Title } = Typography

export default function AdminLogin() {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const handleLogin = async (values) => {
    const { email, password } = values

    const objData = {
      username: email,
      password: password,
    }

    try {
      setLoading(true)
      const res = await axios.post(`${AdminLoginApi}`, objData)

      const data = res.data

      if (data === 'NOTFOUND') {
        toast.warn('Invalid Login Data')
      } else if (data) {
        sessionStorage.setItem('userData', JSON.stringify(data))
        sessionStorage.setItem('authToken', data.token)
        sessionStorage.setItem('role', data.role)

        // Dispatch event so App re-renders
        window.dispatchEvent(new Event('storage'))

        toast.success('Login Successfully!')

        navigate('/admin/ad-dashboard', { replace: true })
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Login Failed')
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    setEmail('')
    setPassword('')

    form.resetFields()

    navigate('/')
  }

  return (
    <div style={styles.container} className="p-2 p-md-0">
      {BUBBLES.map((b, i) => (
        <div
          key={i}
          className="hero-bubble"
          style={{
            width: b.w,
            height: b.w,
            left: b.l,
            top: b.t,
            animationDelay: b.d,
            maxWidth: '50px', // optional limit for small screens
            maxHeight: '50px',
          }}
        />
      ))}

      <Card style={styles.card}>
        <h2 className="login-title"> Admin Login</h2>

        <Form form={form} layout="vertical" onFinish={handleLogin}>
          <Form.Item
            label="Username"
            name="email"
            rules={[
              { required: true, message: 'Please enter username' },
              { type: 'text' },
            ]}
          >
            <Input size="large" placeholder="Enter username" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please enter password' }]}
          >
            <Input.Password size="large" placeholder="Enter password" />
          </Form.Item>

          <Form.Item>
            <div style={{ display: 'flex', gap: 10 }}>
              <Button danger size="large" block onClick={handleCancel}>
                Cancel
              </Button>

              <Button type="primary" htmlType="submit" size="large" block  loading={loading}>
                Login
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg,#0ea5e9,#2563eb)',
    overflow: 'hidden', // hides any bubbles going outside
    padding: '20px', // add some padding for small screens
  },

  card: {
    width: '100%',
    maxWidth: 380,
    borderRadius: 10,
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
  },
}
